let user: IUser | undefined = undefined;

export const setUser = (newUser: typeof user): void => {
    user = newUser;
};

export const getUser = (): typeof user => user;
